import { TaskInvoicingFrequencies, Week } from './../task.constants';
import { Component, ElementRef, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { TaskStatuses } from '../task.constants';
import * as _ from 'lodash';
import { ITask, ITaskAppointmentFilter, ITaskProduct } from '../task.interface';
import { TaskHttpService } from '../task-http.service';
import { AbstractControl, FormControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { debounceTime, distinctUntilChanged, lastValueFrom, Observable, of, startWith, Subscription, switchMap } from 'rxjs';
import { TaskCommentService } from '../task-comment/task-comment.service';
import { ITaskComment } from '../task-comment/task-comment.interface';
import { MatSelect } from '@angular/material/select';
import { Frequency, RRule } from 'rrule';
import { Router } from '@angular/router';
import { TaskModalComponent } from '../task-modal/task-modal.component';
import { TaskSingleComponent } from '../task-single/task-single.component';
import { IWorker } from '../../../workers-page/workers/workers.interface';
import { ICategory } from '../../../categories-page/categories/categories.interface';
import { IAppointment } from '../appoinment/appointment.interface';
import { getEmptyDetailItem } from '../../../../shared/components/detail-item/detail-item.interface';
import { IBillingDocument } from '../../../billing-documents-page/billing-documents/billing-documents.interface';
import { InvoiceStatuses } from '../../../billing-documents-page/billing-documents/billing-documents.constants';
import { UserService } from '../../../users-page/users/users.service';
import { ServiceAgreementHttpService } from '../../../service-agreements-page/service-agreements/service-agreements.service';
import { CategoriesService } from '../../../categories-page/categories/categories.service';
import { ClientsService } from '../../../clients-page/clients/clients.service';
import { ProductsService } from '../../../products-page/products/products.service';
import { WorkersService } from '../../../workers-page/workers/workers.service';
import { DialogService } from '../../../../shared/services/dialog/dialog.service';
import { AuthService } from '../../../../shared/services/auth.service';
import { UtilsService } from '../../../../shared/services/utils.service';
import { AppointmentsService } from '../appoinment/appointment.service';
import { BillingDocumentService } from '../../../billing-documents-page/billing-documents/billing-documents.service';
import { AlertService } from '../../../../shared/services/alert.service';
import { SettingsService } from '../../../settings-page/settings/settings.service';
import { DeliveryNotesService } from '../../../delivery-notes-page/delivery-notes/delivery-notes.service';
import { Broadcaster } from '../../../../shared/components/broadcaster.component';
import { SETTINGS } from '../../../settings-page/settings/settings.constants';
import { IConfirmationDialogOptions } from '../../../../shared/services/dialog/confirmation-dialog/confirmation-dialog-options.interface';
import { IInformationDialogOptions } from '../../../../shared/services/dialog/information-dialog/information-dialog-options.interface';

let self: any;

@Component({
  selector: 'app-next-appointment-modal',
  templateUrl: './next-appointment-modal.component.html',
  styleUrls: ['./next-appointment-modal.component.css']
})
export class NextAppointmentModalComponent implements OnInit {
  private statusInput!: MatSelect;
  @ViewChild('statusInput', { static: false }) set input(input: MatSelect) {
    if (input) this.statusInput = input;
  };
  @ViewChild('bottom', { static: false }) bottomElement!: ElementRef;
  @ViewChild('top', { static: false }) topElement!: ElementRef;

  action: string = '';
  dialog: MatDialogRef<any>;
  readOnly: boolean = false;
  showStart: boolean = true;
  showEnd: boolean = true;
  showEdit: boolean = true;
  loading: boolean = false;
  task!: ITask;
  newStatus!: string;
  comments: any = [];
  form!: UntypedFormGroup;
  formValueChanged: boolean = false;
  saving: boolean = false;
  submitted = false;
  lastDayOfMonth = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0);
  taskInvoicingFrequencies = TaskInvoicingFrequencies;
  taskInvoicingFrequenciesKeys = Object.keys(TaskInvoicingFrequencies);
  taskStatuses: any = TaskStatuses;
  taskStatusesKeys = Object.keys(TaskStatuses);
  taskStatusColors: any = {};
  status!: string;
  // statusEditable: boolean = true;
  filteredWorkers: IWorker[] = [];
  categories: ICategory[] = [];
  $clients: Observable<any> = of();
  workers: IWorker[] = [];
  $products: Observable<any> = of();
  // productItems: ITaskProduct[] = [];
  isDev!: boolean;
  curr!: string;
  subscriptions: Subscription;
  appoinment!: IAppointment;
  subtotal: number = 0;
  tax: number = 0;
  taxPercentage: number = 0;
  total: number = 0;
  notEditableAlert: boolean = false;
  scheduling: boolean = false;
  recurringTask: boolean = false;
  frequency = Frequency;
  week = Week;

  recurrence: any;

  scrollSubscription!: Subscription;
  scrollToComments = false;
  emptyItem = getEmptyDetailItem();

  // recurringWDays = [false, false, false, false, false, false, false];
  private weekdayMap = [
    RRule.SU,
    RRule.MO,
    RRule.TU,
    RRule.WE,
    RRule.TH,
    RRule.FR,
    RRule.SA,
  ];

  rruleSchedule!: string;
  haveRecurrence: { recurrenceRule?: string } = {};
  nextAppointments: any;
  recuFreq!: string;
  recuCount!: string;
  recuDay!: string;
  recuWeek!: string[];
  startDate!: string;
  startDateTime!: string;
  untilDate!: string;
  recuInterval!: string;
  filter!: ITaskAppointmentFilter;
  thereAreMore: boolean = false;

  invoice!: IBillingDocument;
  invoiceStatuses = InvoiceStatuses;
  agreementInvoicing!: boolean;

  constructedForm: boolean = false;
  refreshPage: boolean = false;

  constructor(
    public _TaskHttpService: TaskHttpService,
    public _TaskCommentService: TaskCommentService,
    public _UserService: UserService,
    public _ServiceAgreementHttpService: ServiceAgreementHttpService,
    public _CategoriesService: CategoriesService,
    public _ClientsService: ClientsService,
    public _ProductsService: ProductsService,
    public _WorkersService: WorkersService,
    public dialogRef: MatDialogRef<any>,
    public commentDialogRef: MatDialogRef<any>,
    public movementsDialogRef: MatDialogRef<any>,
    private _dialogService: DialogService,
    private _dialog: MatDialog,
    private _viewContainerRef: ViewContainerRef,
    private fb: UntypedFormBuilder,
    private _AuthService: AuthService,
    private _UtilsService: UtilsService,
    public _AppointmentsService: AppointmentsService,
    // public _ScheduleService: SchedulesService,
    private _BillingDocumentService: BillingDocumentService,
    private _AlertService: AlertService,
    private _SettingsService: SettingsService,
    private _DeliveryNotesService: DeliveryNotesService,
    private _router: Router,
    private _broadcaster: Broadcaster,
  ) {
    self = this;
    this.dialog = dialogRef;
    this.subscriptions = new Subscription();
  }

  formLevel: number = 0;
  setFormLevel() {
    if (this.task.status == 'CANCELLED') this.formLevel = 200;
    else if (this.task.status == 'INVOICED') this.formLevel = 150;
    else if (this.task.status == 'COMPLETED') this.formLevel = 100;
    else if (this.task.status == 'ONGOING') this.formLevel = 75;
    else if (this.task.status == 'SCHEDULED') this.formLevel = 50;
    else if (this.task.status == 'QUOTED') this.formLevel = 25;
    else this.formLevel = 0;
  }

  statusChanged() {
    this.task.status = this.f['status'].value;
    // this.statusEditable = false;
    this.setFormLevel();
  }


  setStatus(newStatus: string, setEditable: boolean = true) {
    this.f['status'].setValue(newStatus);
    this.statusChanged();
  }

  async ngOnInit() {
    this.filter = {
      filters: {},
      sort: '',
      skip: 0,
      limit: 20,
      company: this._AuthService.companyId(),
    };

    this.getStatusColors();
    this.setFormLevel();
    this.curr = this._AuthService.currency();
    this.isDev = this._AuthService.isRole('dev');
    this._WorkersService.getWorkers({
      filters: { isDeleted: false },
      company: this._AuthService.companyId(),
      sort: 'firstname lastname',
      skip: 0,
      limit: 1000
    }).subscribe((workers) => {
      this.workers = workers;
    });

    if (!((this.task?.products as any).length > 0)) this.task.products = [getEmptyDetailItem()];

    if (this.task._id) {
      this.action = 'Modificar';
      await this.getTask(this.newStatus);

      // REFACTOR: Has to wait for the form to be built for the first time
      setTimeout(() => {
        this.constructedForm = true;
      }, 2000);
      // REFACTOR

    }
    else {
      if (this.task.status == 'QUOTED' && this.scheduling) {
        this.action = 'Programar';
        this.task.status = 'SCHEDULED';
      }
      else if (this.task.client) {  //  revisar ????
        this.action = 'Duplicar';
        const rule = (this.task.appointment?.schedule as any)?.recurrenceRule;
        if (rule) {
        }
        // this.task.products = [getEmptyDetailItem()];
      }
      else {
        this.action = 'Crear';
        // this.task.taxPercentage = TaxPercentage;
      }
      await this.buildForm();
      this.constructedForm = true;
    }

    // disable click outside modal
    self.dialogRef.disableClose = true;
    self.dialogRef.backdropClick().subscribe(() => {
      this.closeModal()
    });
  }

  async getStatusColors() {
    this.taskStatusColors = { DEFAULT: 'white', SCHEDULED: '#337AB7', INVOICED: '#FF9E00' };
    this._SettingsService.getCompanySettingValue(SETTINGS.SCH_TASK_OPEN_COLOR)
      .then((color) => { this.taskStatusColors.OPEN = color; this.taskStatusColors.QUOTED = color });
    this._SettingsService.getCompanySettingValue(SETTINGS.SCH_TASK_ONGOING_COLOR)
      .then((color) => { this.taskStatusColors.ONGOING = color });
    this._SettingsService.getCompanySettingValue(SETTINGS.SCH_TASK_COMPLETED_COLOR)
      .then((color) => { this.taskStatusColors.COMPLETED = color });
    this._SettingsService.getCompanySettingValue(SETTINGS.SCH_TASK_CANCELLED_COLOR)
      .then((color) => { this.taskStatusColors.CANCELLED = color });
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  async getTask(newStatus?: string) {

    this._BillingDocumentService.getBillingDocumentByTask(this.task).subscribe(document => {
      if (document)
        if (!(document.status == this.invoiceStatuses.CANCELLED || document.isDeleted))
          this.invoice = document;
    });

    this.recurringTask = false;
    if (newStatus == 'SCHEDULED') this.scheduling = true;
    else this.scheduling = false;
    this.loading = true;
    this.comments = null;

    this._TaskHttpService.getTask(this.task._id || '').subscribe(async (task) => {
      console.log(task)
      this.task = task;

      if (!((this.task.products as any).length > 0)) {
        this.task.products = [getEmptyDetailItem()]
      }

      if (this.task?.workers) {
        this.filteredWorkers = task.workers.filter((worker: any) => !worker.isDeleted);
      }

      /*  REFACTOR ************************************/
      /*
      this.productItems = [];
      for (let el of task.products) {
        const product = await this._ProductsService.getProduct(el.product).toPromise();
        el.product = product;
        this.productItems.push(el);
      }
      */
      /*  REFACTOR ************************************/

      this._AppointmentsService.getAppointment(this.task._id || '').subscribe(async (result) => {
        this.appoinment = result;
        //console.log(this.appoinment)
        this.haveRecurrence = (this.appoinment.schedule) as { recurrenceRule?: any };

        if (this.haveRecurrence) {
          this.filter.filters = {
            schedule: (this.appoinment.schedule as any)?._id,
            startDate: (this.appoinment as any).startDate
          };
          this.getNextAppointment(true);

          const freqMatch = this.haveRecurrence.recurrenceRule ? this.haveRecurrence.recurrenceRule.match(/FREQ=([^;]*)/) : null;
          this.recuFreq = freqMatch ? this.formatFreq(freqMatch[1]) : '';

          const recuIntervalMatch = this.haveRecurrence.recurrenceRule?.match(/INTERVAL=(\d+)/);
          this.recuInterval = recuIntervalMatch ? recuIntervalMatch[1] : '';

          const recuCountMatch = this.haveRecurrence.recurrenceRule?.match(/COUNT=(\d+)/);
          this.recuCount = recuCountMatch ? recuCountMatch[1] : '';

          if (this.recuFreq === 'Mensual') {
            const recuDayMatch = this.haveRecurrence.recurrenceRule?.match(/BYMONTHDAY=([^;]*)/);
            this.recuDay = recuDayMatch ? recuDayMatch[1] : '';
          } else if (this.recuFreq === 'Semanal') {
            const recuWeekMatch = this.haveRecurrence.recurrenceRule?.match(/BYDAY=([^;]*)/);
            this.recuWeek = recuWeekMatch ? this.formatWeek(recuWeekMatch[1]) : [];
          }

          const untilMatch = this.haveRecurrence.recurrenceRule?.match(/UNTIL=(\d{8})T(\d{6})Z/);
          if (untilMatch) {
            const untilDateUTC = new Date(Date.UTC(
              parseInt(untilMatch[1].substring(0, 4)),
              parseInt(untilMatch[1].substring(4, 6)) - 1,
              parseInt(untilMatch[1].substring(6, 8)),
              parseInt(untilMatch[2].substring(0, 2)),
              parseInt(untilMatch[2].substring(2, 4)),
              parseInt(untilMatch[2].substring(4, 6))
            ));
            this.untilDate = untilMatch ? this.formatDateFromISO(untilDateUTC) : '';
          } else {
            this.untilDate = "Luego de " + this.recuCount + " visitas"
          }
          this.startDate = this.appoinment?.createdAt ? this.formatDateFromISO(this.appoinment?.createdAt) : '';
        } else {
          this.startDate = this.task.scheduledStart ? this.formatDateFromISO(this.task.scheduledStart) : '';
          this.untilDate = this.task.scheduledEnd ? this.formatDateFromISO(this.task.scheduledEnd) : '';
        }

        this.startDateTime = this.task.scheduledStart ? this.formatDateTimeFromISO(this.task.scheduledStart) : '';

        await this.buildForm();
        // this.buildeado = true;

        this.loading = false;
        if (newStatus) this.setStatus(newStatus);
        else this.setStatus(this.task.status || '', false);
      });
    });
  }

  getActiveWorkers(workers: any[]): any[] {
    return workers?.filter(worker => !worker.isDeleted) || [];
  }

  hasActiveWorkers(workers: any[]): boolean {
    return this.getActiveWorkers(workers).length > 0;
  }

  getNextAppointment(reset: boolean = false) {
    if (reset) {
      this.filter.skip = 0;
      this.nextAppointments = [];
    }
    this._AppointmentsService.getAppointments(this.filter).subscribe((result) => {
      this.nextAppointments = _.concat(this.nextAppointments, result);

      this.nextAppointments.forEach((appo: any) => {
        appo.startDateTime = this.formatDateTimeFromISO(appo?.task?.scheduledStart);
      });

      const filter: any = this.filter;
      this.thereAreMore = result.length >= filter.limit;
    });
  }

  loadMore() {
    if (this.thereAreMore && !this.loading) {
      const filter: any = this.filter;
      filter.skip += filter.limit;
      this.getNextAppointment(false);
    }
  }

  registerStringBroadcast() {
    this.scrollSubscription = this._broadcaster.on<string>('FinishScrollDown')
      .subscribe(() => {
        this.loadMore();
      });
  }

  scrollDialogToTop() {
    if (this.topElement && this.topElement.nativeElement) {
      this.topElement.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }


  formatFreq(freqString: string): string {
    let frequency: string;
    switch (freqString) {
      case 'DAILY':
        frequency = 'Diaria';
        break;
      case 'WEEKLY':
        frequency = 'Semanal';
        break;
      case 'MONTHLY':
        frequency = 'Mensual';
        break;
      default:
        frequency = 'Otro';
    }
    return frequency;
  }

  formatWeek(dayString: string): string[] {
    const daysArray = dayString.split(',').map(day => Week[day.trim()]);
    daysArray.sort((a, b) => {
      const weekOrder = ['Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb', 'Dom'];
      return weekOrder.indexOf(a) - weekOrder.indexOf(b);
    });

    return daysArray;
  }

  formatDateFromISO(dateString: any) {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  }

  formatDateTimeFromISO(dateString: any) {
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');

    return `${day}/${month}/${year} ${hours}:${minutes}`;
  }


  clientsTerm: string = '';
  get f() { return this.form?.controls; }
  async buildForm() {
    let workers = (this.task.workers || []).map(el => el._id);
    let client = _.get(this.task, 'client._id', '');
    const category: any = _.get(this.task, 'category');
    const categoryId = _.isArray(category) ? (category[0] || {})._id : (category || {})._id;
    const scheduledAt = this.task.scheduledAt ? new Date(this.task.scheduledAt).getTime() : '';
    const scheduledStart = this.task.scheduledStart ? this._UtilsService.date.toLocale(this.task.scheduledStart as any) : '';
    const scheduledEnd = this.task.scheduledEnd ? this._UtilsService.date.toLocale(this.task.scheduledEnd as any) : '';
    this.form = this.fb.group({
      title: [this.task.title],
      client: [this.task.client],
      description: [this.task.description],
      location: [this.task.location, [Validators.required]],
      latitude: [_.get(this.task, 'coordinates[0]'), [Validators.required]],
      longitude: [_.get(this.task, 'coordinates[1]'), [Validators.required]],
      category: [categoryId, [Validators.required]],
      status: [this.task.status, [Validators.required]],
      workers: [workers],
      newProduct: [null],
      // otherCharges: [this.task.otherCharges || 0],
      // discount: [this.task.discount || 0, [Validators.min(0)]],
      subtotal: [this.task.subtotal || 0],
      tax: [this.task.tax || 0],
      taxPercentage: [this.task.taxPercentage || 0],
      total: [this.task.total || 0],

      scheduledAt: [scheduledAt],
      scheduledStart: [scheduledStart],
      scheduledEnd: [scheduledEnd],

      recurringFrequency: [this.recurrence?.recurringFrequency ?? -1],
      recurringInterval: [1],
      recurringWDays: this.fb.array(
        [false, false, false, false, false, false, false].map(val => this.fb.control(val))
      ),
      recurringMDay: [],
      recurringEnd: ['ENDDATE'],
      recurringUntil: [''],
      recurringCount: [1],

      isDeleted: [this.task.isDeleted],
      showStart: [this.showStart],
      showEnd: [this.showEnd],

      quote: [this.task.quote?._id ?? this.task.quote ?? undefined],
      serviceAgreement: [this.task.serviceAgreement?._id ?? this.task.serviceAgreement ?? undefined]
    }, {
      validators: [

      ]
    });
  }

  confirmExit() {
    const modalOptions: IConfirmationDialogOptions = {
      title: "Salir",
      message: "¿Está seguro de que desea salir? Los cambios no se guardarán",
      yesButtonLabel: 'Sí, deseo salir',
      noButtonLabel: 'Cancelar'
    };

    this._dialogService.openConfirmationModal(modalOptions, this._viewContainerRef)
      .subscribe((confirmation: boolean) => {
        if (confirmation) {
          self.dialogRef.close();
        }
      });
  }

  closeModal() {
    // if (!this.readOnly && this.formValueChanged) {
    //   this.confirmExit()
    // } else {
    if (this.refreshPage) {
      self.dialogRef.close(this.task);
    } else {
      self.dialogRef.close();
    }
    // }
  }

  openEditTaskModal(task: ITask, scheduling: boolean = false, readOnly: boolean = true) {
    let config = new MatDialogConfig();
    config.width = '1300px';
    config.maxWidth = '90vw';
    config.hasBackdrop = true;
    config.disableClose = true;
    config.viewContainerRef = this._viewContainerRef;
    self.editTaskDialogRef1 = this._dialog.open(TaskSingleComponent, config);
    self.editTaskDialogRef1.componentInstance.task = task;
    self.editTaskDialogRef1.componentInstance.scheduling = scheduling;
    self.editTaskDialogRef1.componentInstance.readOnly = true;

    self.editTaskDialogRef1.afterClosed().subscribe((result: any) => {
      self.editTaskDialogRef1 = null;
      if (result) this.getTask();
    });
  }

  openUnderConstructionDialog() {
    const modalOptions: IInformationDialogOptions = {
      title: "¡Próximamente!",
      message: "Esta funcionalidad se encuentra en construcción.",
      closeButtonLabel: "Ok"
    };
    this._dialogService.openInformationModal(modalOptions, this._viewContainerRef)
      .subscribe(() => {
        console.log('ok')
      });
  }
}